<div class="bg-white">
  <h3 class="border-bottom p-4">
    <span *ngIf="editMode">{{
      "Sellers.Collections.EditCustomer" | translate
    }}</span>
    <span *ngIf="!editMode">{{
      "Sellers.Collections.AddNewCustomer" | translate
    }}</span>
  </h3>

  <form *ngIf="form" [formGroup]="form" class="p-4">
    <div class="form-group row">
      <div class="mb-3">
        <label>{{
          "Sellers.Collections.CustomerBusinessName" | translate
        }}</label>
        <input
          type="text"
          formControlName="customerBusinessName"
          placeholder="{{
            'Sellers.Collections.CustomerBusinessName' | translate
          }}"
          class="form-control"
        />
        <div
          class="text-danger"
          *ngIf="formValidator.formErrors.customerBusinessName"
        >
          {{ formValidator.formErrors.customerBusinessName }}
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ "Sellers.Collections.FirstName" | translate }}</label>
        <input
          type="text"
          formControlName="firstName"
          placeholder="{{ 'Sellers.Collections.FirstName' | translate }}"
          class="form-control"
        />
        <div class="text-danger" *ngIf="formValidator.formErrors.firstName">
          {{ formValidator.formErrors.firstName }}
        </div>
      </div>

      <div class="col-12 col-sm-6 mb-3">
        <label>{{ "Sellers.Collections.LastName" | translate }}</label>
        <input
          type="text"
          formControlName="lastName"
          placeholder="{{ 'Sellers.Collections.LastName' | translate }}"
          class="form-control"
        />
        <div class="text-danger" *ngIf="formValidator.formErrors.lastName">
          {{ formValidator.formErrors.lastName }}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ "Sellers.Collections.Email" | translate }}</label>
        <input
          type="email"
          formControlName="email"
          placeholder="{{ 'Sellers.Collections.Email' | translate }}"
          class="form-control"
        />
        <div class="text-danger" *ngIf="formValidator.formErrors.email">
          {{ formValidator.formErrors.email }}
        </div>
      </div>

      <div class="col-12 col-sm-6 mb-3">
        <label>{{ "Sellers.Collections.Mobile" | translate }}</label>
        <input
          type="email"
          formControlName="mobile"
          placeholder="{{ 'Sellers.Collections.Mobile' | translate }}"
          class="form-control"
        />
        <div class="text-danger" *ngIf="formValidator.formErrors.mobile">
          {{ formValidator.formErrors.mobile }}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12 col-sm-6 mb-3">
        <label>{{ "Sellers.Collections.Address" | translate }}</label>
        <input
          type="email"
          formControlName="address"
          placeholder="{{ 'Sellers.Collections.Address' | translate }}"
          class="form-control"
        />
      </div>

      <div class="col-12 col-sm-6 mb-3">
        <label>{{ "Sellers.Collections.AdditionalInfo" | translate }}</label>
        <input
          type="email"
          formControlName="additionalInfo"
          placeholder="{{ 'Sellers.Collections.AdditionalInfo' | translate }}"
          class="form-control"
        />
      </div>
    </div>

    <mat-hint *ngIf="success" style="color: green">
      {{ "Sellers.Products.AddeddSuccessfully" | translate }}
      <mat-icon>done</mat-icon>
    </mat-hint>
    <div class="d-flex justify-content-end">
      <button
        class="btn btn-primary"
        (click)="onSubmit()"
        *ngIf="form"
        [disabled]="form.invalid"
      >
        {{ "Sellers.Products.Submit" | translate }}
      </button>
    </div>
  </form>
</div>
